module.exports = __webpack_public_path__ + "img/mini-016.5f9cb280.jpg";